import CustomTypography from "../../components/CustomTypography/CustomTypography";
import DataGrid from "../../components/DataGrid/DataGrid";

/**
 * 
 * @returns All UI Controls
 */
const Stencil: React.FunctionComponent = () => {
    return <div>
        Regular Text:
        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.

        Typography:
        <div style={{ padding: '20px' }}>
            <CustomTypography variant="h1" text="H1: Estimator 2.0.02" />
            <CustomTypography variant="h2" text="H2: Estimator 2.0.02" />
            <CustomTypography variant="h3" text="H3: Estimator 2.0.02" />
            <CustomTypography variant="h4" text="H4: Estimator 2.0.02" />
            <CustomTypography variant="h5" text="H5: Estimator 2.0.02" />
            <CustomTypography variant="h6" text="H6: Estimator 2.0.02" />
            <CustomTypography text="Paragraph: Estimator 2.0.02" />
            <CustomTypography variant="body1" text="Body1: Estimator 2.0.02" />
            <CustomTypography variant="body2" text="Body2: Estimator 2.0.02" />
        </div>

        DataGrid:
        <div style={{ padding: '20px' }}>
            <DataGrid data={[]} />
        </div>
    </div>
}
export default Stencil;